import { KnowledgeDetailPage } from "./KnowledgeDetailPage";
export default KnowledgeDetailPage;
